﻿import ko from 'knockout';
import $ from 'jquery'
import { ITemplateRow } from "./templaterowfactory";

export class TemplateRow implements ITemplateRow {
  public $row: JQuery;
  constructor(private $table: JQuery) {
    this.$row = this.getRow();
  }
  public static wireup: string = "[data-et-template]";

  public static canBuild($table): boolean {
    var templateRow = $table.find("[data-et-template]");
    if (templateRow.length > 0)
      return true;
    return false;
  }

  getRow(): JQuery {
    var templateRow = this.$table.find("[data-et-template]");
    if (templateRow.length != 0) {
      this.$row = templateRow;
      return this.$row;
    }
    return null;
  }

  public init(): boolean {
    if (this.$row.length == 0)
      return false;
    this.$row.attr("data-template", "true")
      .removeAttr("data-init")
      .removeAttr("data-et-template");
    this.$row.find("td input").each(function () {
      var input = $(this);
      var binder = input.attr('data-bind');
      if (binder)
        input.attr("data-bind", input.attr("data-bind").replace("init, ", ""));
    });
    return true;
  }
}
